import {Component, Input, OnInit} from '@angular/core';
import {UserAdminComponentTypeEnum} from "../user-admin-component-type.enum";
import {AccountResponse} from "../../../../shared/model/response/account-response.model";
import {DropdownAbled} from "../../../../shared/interfaces/dropdown-abled";
import {UserRoleEnum} from "../../../../shared/enums/user-role.enum";

@Component({
    selector: 'app-user-table-list',
    templateUrl: './user-table-list.component.html',
    standalone: false
})
export class UserTableListComponent implements OnInit, DropdownAbled<AccountResponse> {

  protected readonly UserAdminComponentTypeEnum = UserAdminComponentTypeEnum;

  @Input('componentType') componentType: UserAdminComponentTypeEnum = null;
  @Input('users') users: AccountResponse[]
  @Input('hasData') hasEvents: boolean

  public mouseEvent: MouseEvent
  selectedUser: AccountResponse

  constructor() {
  }

  ngOnInit(): void {
  }

  // dropdown interface ----------------
  selectObjectForDropDown(selectedObject: AccountResponse): void {
    this.selectedUser = selectedObject;
  }

  setMouseEvent($mouseEvent: MouseEvent): void {
    this.mouseEvent = $mouseEvent
  }

  updateUserFromTable($user: AccountResponse) {
    const elementIndex = this.users.findIndex(el => el.id == $user.id)
    this.users[elementIndex] = $user
  }

  removeEventFromList($user: AccountResponse) {
    this.users = this.users.filter(el => el.id !== $user.id)
    if (this.users.length == 0) this.hasEvents = false
  }

  onApiRoleChangeSuccess($event: AccountResponse) {

    if ($event.role.code === UserRoleEnum.NORMAL) {
      this.removeEventFromList($event)
    } else this.updateUserFromTable($event)


  }
}
